export const getColorForName = (name: string, textColor = false) => {
  // Generate a consistent color based on the name
  const colors = ["orange-500", "purple-500", "green-500", "blue-500", "pink-500", "teal-500", "indigo-500", "yellow-500", "red-500", "cyan-500"];

  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }

  const color = colors[Math.abs(hash) % colors.length];
  return textColor ? `text-${color}` : `bg-${color}`;
};
